import React from "react";
import { useIntl, FormattedMessage } from "react-intl";
import Layout from "../../components/Layout"
import Seo from "../../components/Seo";
import { StaticImage } from "gatsby-plugin-image"

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { solid, regular, brands } from '@fortawesome/fontawesome-svg-core/import.macro'

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Global } from "@emotion/react";
import { emotionGlobalCss } from "../../styles/ductless-heat-pump";

//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import {faStar, faCheck, faThumbsUp, faHandshake } from "@fortawesome/pro-regular-svg-icons"
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import DiamondIcon from '@mui/icons-material/Diamond';
import PsychologyIcon from '@mui/icons-material/Psychology';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';
// import { faSlidersH } from "@fortawesome/pro-light-svg-icons"
// import { faGem, faCheckCircle } from "@fortawesome/pro-solid-svg-icons"

export default function DuctlessHeatPump() {
	const intl = useIntl();
	const t = intl.formatMessage;
	return (
		<Layout>
			<Global styles={emotionGlobalCss} />
			<Seo />
			<div>
				<div className="heroImage" style={{ backgroundImage: `url(https://aee-image.s3.ca-central-1.amazonaws.com/AndmarLandscape.png)` }}>
					<div className="wrap">
						<div className="innerHeroImage">
							<h1 
							// itemprop="headline"
							><FormattedMessage id="ductless-heat-pump.maintext1" /></h1>
						</div>
					</div>
				</div>
				<div className="jumpMenu">
					<div className="wrap">
						<a href="#models" className="links">
							{/* <i><FontAwesomeIcon icon={faStar} /></i> */}
							<FormattedMessage id="jump-menu.title1" />
						</a>
						<a href="#why-ductless" className="links">
							{/* <i><FontAwesomeIcon icon={faStar} /></i> */}
							<FormattedMessage id="jump-menu.title2" />
						</a>
						<a href="#why-lg" className="links">
							{/* <i><FontAwesomeIcon icon={faStar} /></i> */}
							<FormattedMessage id="jump-menu.title3" />
						</a>
						<a href="#payment-options" className="links">
							{/* <i><FontAwesomeIcon icon={faStar} /></i> */}
							<FormattedMessage id="jump-menu.title4" />
						</a>
					</div>
				</div>
				<div className="site-inner">
					<div className="content-sidebar-wrap">
						<main className="content" id="genesis-content">
							<div className="greyBack" id="models">
								<div className="wrap">
									<div className="titleBox">
										<h2><FormattedMessage id="models" /></h2>
									</div>
									<div className="modelsFlex">
										<a  href="https://drive.google.com/file/d/1gzNTAKTxZ5sz2KWCdnZ2F5-MCaSA7_B3/view" download="tt" style={{textDecoration:"none" }} target="_blank">
										<div className="eachModel"><StaticImage src={"../../images/LGPrestigeImage.png"} alt={t({ id: "altTag.LGPrestigeImage" })} imgStyle={{objectFit: "contain"}}/>
											<div className="modelBox">
												<h4><FormattedMessage id="model.title1" /></h4>
												<p><FormattedMessage id="model.text1" /></p>
											</div>
										</div>
										</a>
										<div className="eachModel"><StaticImage src={"../../images/LGGlossWhiteImage.jpg"} alt={t({ id: "altTag.LGGlossWhiteImage" })} imgStyle={{objectFit: "contain"}}/>
											<div className="modelBox">
												<h4><FormattedMessage id="model.title2" /></h4>
												<p><FormattedMessage id="model.text2" /></p>
											</div>
										</div>
										<div className="eachModel"><StaticImage src={"../../images/LGMirrorImage.jpg"} alt={t({ id: "altTag.LGMirrorImage" })} imgStyle={{objectFit: "contain"}}/>
											<div className="modelBox">
												<h4><FormattedMessage id="model.title3" /></h4>
												<p><FormattedMessage id="model.text3" /></p>
											</div>
										</div>
										<div className="eachModel"><StaticImage src={"../../images/LGCassetteImage.jpeg"} alt={t({ id: "altTag.LGCassetteImage" })} imgStyle={{objectFit: "contain"}}/>
											<div className="modelBox">
												<h4><FormattedMessage id="model.title4" /></h4>
												<p><FormattedMessage id="model.text4" /></p>
											</div>
										</div>
										<div className="eachModel"><StaticImage src={"../../images/LGMultiImage.jpg"} alt={t({ id: "altTag.LGMultiFImage" })} imgStyle={{objectFit: "contain"}}/>
											<div className="modelBox">
												<h4><FormattedMessage id="model.title5" /></h4>
												<p><FormattedMessage id="model.text5" /></p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div id="why-lg" className="benefits">
								<div className="wrap">
									<div className="benefitsDiv">
										<div className="titleBox">
											<h2><FormattedMessage id="why-ductless.maintitle" /></h2>
										</div>
										<div className="allBenefits">
											<div className="theBenefit">
												<StaticImage className="hover" src={"../../images/MoneyBagSImage.png"} alt={t({ id: "altTag.MoneyBagSImage" })} imgStyle={{objectFit: "contain"}}/>
												<StaticImage className="noHover" src={"../../images/MoneyBagLImage.png"} alt={t({ id: "altTag.MoneyBagLImage" })} imgStyle={{objectFit: "contain"}}/>
												<h3><FormattedMessage id="why-ductless.title1" /></h3>
												<p><FormattedMessage id="why-ductless.text1" /></p>
											</div>
											<div className="theBenefit">
												<StaticImage className="hover" src={"../../images/ApprovalSignSImage.png"} alt={t({ id: "altTag.ApprovalSignSImage" })} imgStyle={{objectFit: "contain"}}/>
												<StaticImage className="noHover" src={"../../images/ApprovalSignLImage.png"} alt={t({ id: "altTag.ApprovalSignLImage" })} imgStyle={{objectFit: "contain"}}/>
												<h3><FormattedMessage id="why-ductless.title2" /></h3>
												<p><FormattedMessage id="why-ductless.text2" /></p>
											</div>
											<div className="theBenefit">
												<StaticImage className="hover" src={"../../images/EvolutionSImage.png"} alt={t({ id: "altTag.EvolutionSImage" })} imgStyle={{objectFit: "contain"}}/>
												<StaticImage className="noHover" src={"../../images/EvolutionLImage.png"} alt={t({ id: "altTag.EvolutionLImage" })} imgStyle={{objectFit: "contain"}}/>
												<h3><FormattedMessage id="why-ductless.title3" /></h3>
												<p><FormattedMessage id="why-ductless.text3" /></p>
											</div>
											<div className="theBenefit">
												<StaticImage className="hover" src={"../../images/BulbSImage.png"} alt={t({ id: "altTag.BulbSImage" })} imgStyle={{objectFit: "contain"}}/>
												<StaticImage className="noHover" src={"../../images/BulbLImage.png"} alt={t({ id: "altTag.BulbLImage" })} imgStyle={{objectFit: "contain"}}/>
												<h3><FormattedMessage id="why-ductless.title4" /></h3>
												<p><FormattedMessage id="why-ductless.text4" /></p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div id="why-ductless">
								<div className="wrap">
									<div className="whyDuct">
										<div className="ductContent">
											<h2><FormattedMessage id="why-lg.maintitle" /></h2>
											<p><strong><span style={{ color: "#70c000" }}>
												<VerifiedUserRoundedIcon sx={{marginBottom:"-5px",marginRight:"2px"}}/>
												<FormattedMessage id="why-lg.title1" />
												</span></strong></p>
											<p><FormattedMessage id="why-lg.text1" /></p>
											<p><strong><span style={{ color: "#70c000" }}>
												<VerifiedUserRoundedIcon sx={{marginBottom:"-5px",marginRight:"2px"}}/>
												<FormattedMessage id="why-lg.title2" />
												</span></strong></p>
											<p><FormattedMessage id="why-lg.text2" /></p>
										</div>
										<div className="ductImg">
											<div><StaticImage src={"../../images/LGLogoImage.png"} alt={t({ id: "altTag.LGLogoImage" })} /></div>
											<div><StaticImage src={"../../images/LGWarrantyImage.png"} alt={t({ id: "altTag.LGWarrantyImage" })} /></div>
										</div>
									</div>
								</div>
							</div>
							<div className="wrap">
								<div className="qualities">
									<div className="titleBox">
										<h2><FormattedMessage id="why-andmar.maintitle" /></h2>
										<p><FormattedMessage id="why-andmar.text" /></p>
									</div>
									<div className="allQualities">
										<div className="theQuality">
											<PsychologyIcon sx={{fontSize:"50px", color:"#70c000"}}/>
											<h3><FormattedMessage id="attribute1.title" /></h3>
											<p><FormattedMessage id="attribute1.text" /></p>
										</div>
										<div className="lineQualities"></div>
										<div className="theQuality">
											<DiamondIcon sx={{fontSize:"50px", color:"#70c000"}}/>
											<h3><FormattedMessage id="attribute2.title" /></h3>
											<p><FormattedMessage id="attribute2.text" /></p>
										</div>
										<div className="lineQualities"></div>
										<div className="theQuality">
											<ThumbUpAltIcon sx={{fontSize:"50px", color:"#70c000"}}/>
											<h3><FormattedMessage id="attribute3.title" /></h3>
											<p><FormattedMessage id="attribute3.text" /></p>
										</div>
										<div className="lineQualities"></div>
										<div className="theQuality">
											<VolunteerActivismIcon sx={{fontSize:"50px", color:"#70c000"}}/>
											<h3><FormattedMessage id="attribute4.title" /></h3>
											<p><FormattedMessage id="attribute4.text" /></p>
										</div>
										<div className="lineQualities"></div>
									</div>
								</div>
							</div>
							<div className="greyBack" id="payment-options">
								<div className="wrap">
									<div className="titleBox">
										<h2><FormattedMessage id="payment-options.title" /></h2>
										<p><FormattedMessage id="payment-options.text" /></p>
									</div>
									<div className="productFlex">
										<div className="eachP">
											<div className="innerP">
												<div className="productImg">
													<StaticImage src={"../../images/MoneyBillImage.png"} alt={t({ id: "altTag.MoneyBillImage" })} />
												</div>
												<h3><FormattedMessage id="payment-option1.title" /></h3>
												<div className="pricesPro">
													<div className="eachPrice">
														<div className="leftPrice"><FormattedMessage id="payment-option1.attributetag1" /></div>
														<div className="rightPrice"><FormattedMessage id="payment-option1.attributetext1" /></div>
													</div>
													<div className="eachPrice">
														<div className="leftPrice"><FormattedMessage id="payment-option1.attributetag2" /></div>
														<div className="rightPrice"><FormattedMessage id="payment-option1.attributetext2" /></div>
													</div>
													<div className="eachPrice">
														<div className="leftPrice"><FormattedMessage id="payment-option1.attributetag3" /></div>
														<div className="rightPrice"><FormattedMessage id="payment-option1.attributetext3" /></div>
													</div>
													<div className="eachPrice">
														<div className="leftPrice"><FormattedMessage id="payment-option1.attributetag4" /></div>
														<div className="rightPrice"><FormattedMessage id="payment-option1.attributetext4" /></div>
													</div>
													<div className="eachPrice">
														<div className="leftPrice"><FormattedMessage id="payment-option1.attributetag5" /></div>
														<div className="rightPrice"><FormattedMessage id="payment-option1.attributetext5" /></div>
													</div>
													<div className="eachPrice">
														<div className="leftPrice"><FormattedMessage id="payment-option1.attributetag6" /></div>
														<div className="rightPrice">
														<CheckCircleIcon/>
															</div>
													</div>
												</div>
											</div>
											<a href="http://andmar.cloud" ><FormattedMessage id="payment-option1.cta-button" /></a>
										</div>
										<div className="eachP">
											<div className="innerP">
												<div className="productImg">
													<StaticImage src={"../../images/MoneyBagImage.png"} alt={t({ id: "altTag.MoneyBagImage" })} />
												</div>
												<h3><FormattedMessage id="payment-option2.title" /></h3>
												<div className="pricesPro">
													<div className="eachPrice">
														<div className="leftPrice"><FormattedMessage id="payment-option2.attributetag1" /></div>
														<div className="rightPrice"><FormattedMessage id="payment-option2.attributetext1" /></div>
													</div>
													<div className="eachPrice">
														<div className="leftPrice"><FormattedMessage id="payment-option2.attributetag2" /></div>
														<div className="rightPrice"><FormattedMessage id="payment-option2.attributetext2" /></div>
													</div>
													<div className="eachPrice">
														<div className="leftPrice"><FormattedMessage id="payment-option2.attributetag3" /></div>
														<div className="rightPrice"><FormattedMessage id="payment-option2.attributetext3" /></div>
													</div>
													<div className="eachPrice">
														<div className="leftPrice"><FormattedMessage id="payment-option2.attributetag4" /></div>
														<div className="rightPrice">
														
															<CheckCircleIcon/>
															</div>
													</div>
													<div className="eachPrice">
														<div className="leftPrice"><FormattedMessage id="payment-option2.attributetag5" /></div>
														<div className="rightPrice">
															<CheckCircleIcon/>
															</div>
													</div>
													<div className="eachPrice">
														<div className="leftPrice"><FormattedMessage id="payment-option2.attributetag6" /></div>
														<div className="rightPrice">
															<CheckCircleIcon/>
															</div>
													</div>
													<div className="eachPrice">
														<div className="leftPrice"><FormattedMessage id="payment-option2.attributetag7" /></div>
														<div className="rightPrice"></div>
													</div>
												</div>
											</div><a href="http://andmar.cloud" target=""><FormattedMessage id="payment-option2.cta-button" /></a>
										</div>
									</div>
								</div>
							</div>
						</main>
					</div>
				</div>
			</div>
		</Layout>
	)
};